import {
  Stack,
  Button,
  useMediaQuery,
  useTheme,
  AppBar,
  Typography,
} from '@mui/material';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

const LandingButtons: React.FC = () => {
  const theme = useTheme();
  const nonMobile = useMediaQuery(theme.breakpoints.up('sm'));
  const user = useSelector((state: RootState) => state.auth.user);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <AppBar position="relative" sx={{ bgcolor: 'transparent' }} elevation={0}>
      <Stack
        direction="row"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
        p={1}
      >
        <Link
          to="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <img src="/logo.png" alt="" style={{ width: 35, height: 'auto' }} />
          <Typography
            variant="h5"
            sx={{ ml: 1 }}
            fontWeight="bold"
            color="secondary.main"
          >
            DealerScout
          </Typography>
        </Link>
        <Stack direction="row" gap={nonMobile ? 2 : 1} alignItems="center">
          {nonMobile && (
            <Button
              variant="text"
              color="secondary"
              sx={{ fontWeight: 700 }}
              component={Link}
              to="/dealer"
            >
              For Dealers
            </Button>
          )}
          {user ? (
            <Button
              component={Link}
              to="/deals"
              variant="contained"
              color="highlight"
              sx={{ fontWeight: 700 }}
            >
              My Deals
            </Button>
          ) : (
            <Button
              component={Link}
              to="/login"
              variant="contained"
              color="highlight"
              sx={{ fontWeight: 700 }}
            >
              Log In
            </Button>
          )}
        </Stack>
      </Stack>
    </AppBar>
  );
};

export default LandingButtons;
